'use client'

import { ThemeProvider } from 'next-themes'
import { TooltipProvider } from '@/components/ui/tooltip'
import { SidebarProvider } from '@/contexts/sidebar-context'
import { AuthProvider } from '@/providers/auth-provider'

export function Providers({ children }: Readonly<{ children: React.ReactNode }>) {
	return (
		<ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} disableTransitionOnChange={false}>
			<AuthProvider>
				<TooltipProvider delayDuration={200}>
					<SidebarProvider>{children}</SidebarProvider>
				</TooltipProvider>
			</AuthProvider>
		</ThemeProvider>
	)
}
